const notacaoNumero = (valor: number) => {
    const sinal = valor < 0 ? '-' : ''
    const valorAbsoluto = Math.abs(valor)

    if (valorAbsoluto >= 1e9) return sinal + (valorAbsoluto / 1e9).toFixed(0) + 'B'
    if (valorAbsoluto >= 1e6) return sinal + (valorAbsoluto / 1e6).toFixed(0) + 'M'
    if (valorAbsoluto >= 1e3) return sinal + (valorAbsoluto / 1e3).toFixed(0) + 'k'

    return valor.toString()
}

export default notacaoNumero
